import { render } from "./ConversationBox.vue?vue&type=template&id=633e0d53"
import script from "./ConversationBox.vue?vue&type=script&lang=js"
export * from "./ConversationBox.vue?vue&type=script&lang=js"
script.render = render

export default script